import { CloseOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import { Mask } from "antd-mobile";
import { Trans, useTranslation } from "react-i18next";
import { useLoading } from "../../../../context/modules/LoadingContext";
import queryKey from "../../../../enumerations/queryKey";
import styles from "./style.module.scss";

const RedEnvelopePopup = ({
  setNextSorting,
  bonusAmount = 0,
  showRedEnvelopePopup,
  setShowRedEnvelopePopup,
  applyRedEnvelope,
  isApplied,
}) => {
  const { t } = useTranslation();
  const { setIsLoading } = useLoading();
  const cache = useQueryClient();

  const closeModal = () => {
    setShowRedEnvelopePopup(false);
    setNextSorting();
    if (isApplied) {
      cache.invalidateQueries([queryKey.RED_ENVELOPE]);
    }
  };

  const handleSubmitRedEnvelope = () => {
    setIsLoading(true);
    applyRedEnvelope();
  };

  const renderResult = () => {
    return (
      <div
        className={styles.imgContainer}
        style={{ background: `url("/images/redEnvelope/popup-bg.png") no-repeat center / cover` }}
      >
        <div className={styles.top}>
          <div className={styles.title}>
            <Trans
              i18nKey={"redenvelope.title"}
              values={{ amount: bonusAmount }}
              components={{ span: <span /> }}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.desc}>{t("redenvelope.desc")}</div>
          <div className={styles.button} onClick={closeModal}>
            {t("appDownload.addToHome.ok").toUpperCase()}
          </div>
        </div>
      </div>
    );
  };

  const renderApply = () => {
    return (
      <div
        className={styles.applyImgContainer}
        style={{ background: `url("/images/redEnvelope/popup-bg0.png") no-repeat center / cover` }}
      >
        <div className={styles.top}>
          <div className={styles.title}>
            <Trans
              i18nKey={"redenvelope.apply.title"}
              values={{ amount: bonusAmount }}
              components={{ span: <span /> }}
            />
          </div>
          <div className={styles.subtitle}>{t("redenvelope.apply.subtitle")}</div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.desc}>{t("redenvelope.apply.desc")}</div>
          <div className={styles.button} onClick={handleSubmitRedEnvelope}>
            {t("normal.get").toUpperCase()}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Mask
      visible={showRedEnvelopePopup}
      opacity="thick"
      onMaskClick={closeModal}
      getContainer={() => document.body}
    >
      <div className={styles.container}>
        {isApplied ? renderResult() : renderApply()}
        <div className={styles.footer}>
          <CloseOutlined className={styles.close} onClick={closeModal} />
        </div>
      </div>
    </Mask>
  );
};

export default RedEnvelopePopup;
